/**
 * ログインページ: クライアント側バリデーション（静的ビルド）
 * 送信先 URL は本番で form の action に合わせてください。
 */
import { validateLoginForm, initLoginFormValidation } from './login-form-validation.js';

function getForm() {
	return document.querySelector('form#login-form');
}

function initFormPage() {
	const form = getForm();
	if (!form) return;

	initLoginFormValidation(form);

	form.addEventListener('submit', (e) => {
		if (!validateLoginForm(form)) {
			e.preventDefault();
		}
	});
}

export function initLoginFlow() {
	if (!document.querySelector('section.login')) return;
	initFormPage();
}
